module.exports = __webpack_public_path__ + "static/media/Navisworks.fb3c8e02.png";